import "../styles/Forgot.css";
import image from "../assets/Studds.png";
import Studds_Logo from "../assets/Studds_logo_white.png";
import { MdVisibility, MdVisibilityOff} from "react-icons/md";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ShowSnacker from "./DashBoard/ShowSnacker";
import { apiFetch } from "../services/api";

function Forgot() {
  const navigate = useNavigate();

  const [PasswordHidden, PasswordVisible] = useState(false);
  const [ConfirmPasswordHidden, ConfirmPasswordVisible] = useState(false);
  const [EmailAddress, setEmailAddress] = useState('');
  const [Password, setPassword] = useState('');
  const [ConfirmPassword, setConfirmPassword] = useState('');

  const [snack, setSnack] = useState({open: false,message: "",type: "info"});
  const ShowSnackbar = (message, type= "info") => {
    setSnack({ open: true, message, type});
  };


  const validatePassword = (password: string) =>  {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    return passwordRegex.test(password);
  };

  async function ResetPassword() {
    try{
      if(!EmailAddress || !Password || !ConfirmPassword) {
        // console.log("Please fill in all fields.");
        ShowSnackbar("Please fill in all fields.","info");
        return;
      }

      if(ConfirmPassword !== Password){
        // console.log("Passwords are not matching.");
        ShowSnackbar("Passwords are not matching.","error");
        return;
      }

      if (!validatePassword(Password)) {
        ShowSnackbar("Password needs 8 chars, 1 uppercase, 1 number & 1 special character.","info");
        return;
      }

      if (!validatePassword(ConfirmPassword)) {
        ShowSnackbar("Password needs 8 chars, 1 uppercase, 1 number & 1 special character.","info");
        return;
      }

      // console.log(EmailAddress,Password,ConfirmPassword);
      
      const response = await apiFetch("/admin/forgotpassword", {
        method: 'PUT',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({emailId: EmailAddress, password: Password}),
      });
      // console.log(response);
    
      if(response.status === 200){
        // console.log("Password reset successfully, Please login");
        ShowSnackbar("Password reset successfully, Please login","success");
        FormReset();
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else if(response.status === 404) {
        // console.log("Entered Email incorrect");
        ShowSnackbar("Email address incorrect","error")
      }
      // console.log("response",response);
    } catch(err){
      // console.error("Error during reset password", err); 
      ShowSnackbar("Please try again after some times","error");
    }
    
  }

 const FormReset = () =>{
  setConfirmPassword('');
  setEmailAddress('');
  setPassword('');
 }
  return(
    <div className="forgotpassword">
      <div id="reset-password-card">
           <div id="reset-right"> 
              <img src={Studds_Logo} width="190px" height="80px" alt="logo" className="studds_logo"/>
            <form>
              {/* <h3 className="title">Admin Login</h3> <br/> */}
              <label>Email </label> <input type="text" placeholder='Email' value={EmailAddress} onChange={(e) => setEmailAddress(e.target.value)} /> 
              <label>New Password:</label> 
                <div className="password-wrapper">
                    <input type={PasswordHidden ? "text" : "password"} placeholder='Password' value={Password.substring(0, 10)} onChange={(e) => setPassword(e.target.value)} />
                    <span className="eye-icon" onClick={()=>PasswordVisible(!PasswordHidden)}> {PasswordHidden ? <MdVisibility size={20}/> : <MdVisibilityOff size={20}/>}</span>
                </div> 
              <label>Confirm New Password:</label> 
                <div className="password-wrapper">
                    <input type={ConfirmPasswordHidden ? "text" : "password"} placeholder='Confirm Password' value={ConfirmPassword.substring(0, 10)} onChange={(e) => setConfirmPassword(e.target.value)} />
                    <span className="eye-icon" onClick={()=>ConfirmPasswordVisible(!ConfirmPasswordHidden)}> {ConfirmPasswordHidden ? <MdVisibility size={20}/> : <MdVisibilityOff size={20}/>}</span>
                </div>
              <button type='submit' id="login-button" onClick={(e) => {e.preventDefault();ResetPassword();}}> Submit </button> <br/>
            </form>
          </div>
          <div id="reset-left">
            <img src={image} alt="img" className="login-image" ></img>
          </div>
         
        </div>  
      {/* <div className="reset-password"> */}
        {/* <div id="reset-page">
          <span>Reset Your Password</span><br/>
        </div> */}
              
      {/* </div> */}
      <ShowSnacker open={snack.open} message={snack.message} type={snack.type} className="forgot-snackbar" onClose={() => setSnack(s => ({ ...s, open: false }))}/>
    </div>
  );
}

export default Forgot;